"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var polished_1 = require("polished");
var Avatar = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b;
    return (react_1["default"].createElement("svg", { version: "1.1", id: "Layer_1", x: "0px", y: "0px", viewBox: "0 0 16 16", xmlSpace: "preserve", width: size, height: size, style: { marginRight: polished_1.rem(8), borderRadius: '100%' } },
        react_1["default"].createElement("circle", { id: "Ellipse_400", fill: "#F9F9F9", cx: "8", cy: "8", r: "8" }),
        react_1["default"].createElement("g", null,
            react_1["default"].createElement("defs", null,
                react_1["default"].createElement("circle", { id: "SVGID_1_", cx: "8", cy: "8", r: "8" })),
            react_1["default"].createElement("clipPath", { id: "SVGID_2_" }),
            react_1["default"].createElement("path", { id: "Path_1096", fill: "#DDDDDD", d: "M11.7,11.6C9.9,11,9.6,10.4,9.6,9.3c0-0.1,0-0.2,0-0.3c0.1-0.3,0.6-0.3,0.8-1.3\n c0.1-0.5,0.4-0.1,0.5-1.3c0-0.5-0.3-0.5-0.3-0.5c0.1-0.4,0.2-0.9,0.3-1.3C10.9,4,10.4,2.3,8,2.3l0,0C5.6,2.3,5.1,4,5.1,4.6\n c0.1,0.4,0.1,0.9,0.3,1.3c0,0-0.3,0.1-0.3,0.5c0.1,1.2,0.4,0.8,0.5,1.3c0.2,1,0.6,0.9,0.8,1.3c0,0.1,0,0.1,0,0.3\n c0,1.1-0.4,1.7-2.1,2.3s-2.6,1.1-2.6,1.6V16h12.6v-2.8C14.3,12.7,13.4,12.2,11.7,11.6z" }))));
};
exports["default"] = Avatar;
